import { Div } from "@tblabs/truffle";
import { BlogContentProvider } from "../../Services/Content/BlogContentProvider";
import { Heading } from "../../Components/Heading";
import { AricleBox } from "../Category/AricleBox";
import { AdminMenu } from "../../Components/Admin/AdminMenu";
import { Page } from "../Product/Page";
import { PageFooter } from "../Main/PageFooter";
import { ShopContentProvider } from "../../Services/Content/ShopContentProvider";


export class BlogPage extends Page
{
    constructor(_blog: BlogContentProvider, _shop: ShopContentProvider)
    {
        super("specTeam.pl - Nasze artykuły");

        this.Append(new PageFooter(_shop));

        this.Content(async (body) =>
        {
            await _blog.Load();
            await _shop.Load();
            
            const categories = await _blog.GetPublicCategories();

            body.Append(
                new Div("container").Append(
                    _blog.IsAuthorized && new AdminMenu({
                        "Dodaj artykuł": "blog/add",
                        "Zarządzaj kolejnością": "blog/edit",
                    }),

                    ...categories.flatMap(group => [
                        new Heading(group.Name, 5).Class("section-title").Color("#ccc"),
                        new Div("products").Append(
                            ...group.Articles.map(x => new AricleBox(x).ApplyStyle(x.Visible, false, "opacity", "0.3", "1")),
                        ),
                    ]),
                )
            )
        });
    }
}
